module.exports = __webpack_public_path__ + "img/矩形 5 拷贝 7.c1014912.png";